// extracted by mini-css-extract-plugin
module.exports = {"comment":"styles_comment__3kFuk"};